import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AllEventsFragmentFragmentDoc } from '../fragments/allEventsFragement.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllEventsQueryVariables = Types.Exact<{
  range?: Types.InputMaybe<Types.Range>;
}>;


export type AllEventsQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'Event', id: string, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, event_participants?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_id?: string | null }> | null }> }> | null }> | null };


export const AllEventsDocument = gql`
    query allEvents($range: Range) {
  events(range: $range) {
    ...allEventsFragment
  }
}
    ${AllEventsFragmentFragmentDoc}`;

/**
 * __useAllEventsQuery__
 *
 * To run a query within a React component, call `useAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEventsQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useAllEventsQuery(baseOptions?: Apollo.QueryHookOptions<AllEventsQuery, AllEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, options);
      }
export function useAllEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEventsQuery, AllEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, options);
        }
export type AllEventsQueryHookResult = ReturnType<typeof useAllEventsQuery>;
export type AllEventsLazyQueryHookResult = ReturnType<typeof useAllEventsLazyQuery>;
export type AllEventsQueryResult = Apollo.QueryResult<AllEventsQuery, AllEventsQueryVariables>;